import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, TEXT_GRAY, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

const ASIDE_WIDTH = 350;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
  padding: 20px 0;

  ${media.tabletL`
    flex-direction: row;
    padding: 40px 0;
  `};
`;

export const SliderWrapper = styled.div`
  overflow: hidden;
  padding-bottom: 60px;
  padding-top: 40px;

  ${media.tabletL`
    align-self: center;
    padding-top: 0;
    margin-right: 50px;
    margin-left: 50px;
    max-width: 500px;
    order: -1;
    width: 70%;
  `};

  > div > div {
    width: 100%;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: none;

  ${media.tabletL`
    max-width: ${ASIDE_WIDTH}px;
    padding-bottom: 60px;
    width: 100%;
  `};
`;

export const VariantSelectWrapper = styled.div`
  max-width: none;
  width: 100%;
  margin: 0 auto;
  margin-top: 1em;
  padding: 0 ${MOBILE_PADDING}px;

  ${media.tabletL`
    max-width: ${ASIDE_WIDTH}px;
    margin-top: 2em;
    padding: 0;
  `};
`;

export const TextWrapper = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  padding: 0 ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    padding: 0;
  `};

  h5 {
    margin: 1em 0 0;
    text-transform: uppercase;
    color: ${BLACK};
  }
  h6 {
    margin: 1.5em 0 1em;
    color: ${BLACK};
  }
  h2 {
    margin: 0.8em 0 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${TEXT_GRAY.COMMON_5};

    ${media.tabletL`
      margin: 0.3em 0 0;
    `};

    span {
      text-transform: none;
    }
  }

  p {
    margin: 2em 0;

    ${media.tabletL`
      margin: 1em 0;
    `};
  }

  ul {
    margin-left: 25px;
  }
  li {
    margin: 0.5em 0;
    color: ${BLACK};
  }
`;

export const VariantSelect = styled.div`
  position: relative;
  display: flex;
  border-top: 1px solid #d2d2d2;
  border-bottom: 1px solid #d2d2d2;

  ${media.tabletL`
    max-width: 300px;
  `};

  &::after {
    content: '';
    display: inline-block;
    height: 0.6em;
    width: 0.6em;
    position: absolute;
    top: 44%;
    right: 0.2em;
    transform: translateY(-50%) rotate(135deg);
    border-style: solid;
    border-width: 0.15em 0.15em 0 0;
    vertical-align: top;
  }

  select {
    background: transparent;
    border: 0;
    color: ${BLACK};
    flex: 1;
    outline: none;
    -webkit-appearance: none;

    &::-ms-expand {
      display: none;
    }

    font-size: 16px;

    ${media.tabletL`
      font-size: 19px;
    `};
  }

  p {
    display: inline-block;
    margin: 0.5em;
    color: ${BLACK};
  }
`;

export const TaxNote = styled.div`
  color: ${BLACK};
  font-size: 14px;
  margin: 10px 20px 0;

  ${media.tabletL`
    margin: 10px 0 0;
  `};
`;

export const DesktopSelector = styled.div`
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const MobileSelector = styled.div`
  display: block;

  ${media.tabletL`
    display: none;
  `};
`;

export const ImageContainer = styled.div`
  min-height: 100px;

  ${media.tabletL`
    height: 500px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/ProductPage/ProductHeroOverview/ProductHeroOverview.style.js